import styled from "styled-components";

export const Form = styled.form`
	text-align: left;
	width: 100%;
	border-radius: 4px;
	box-shadow: 0 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%),
		0px 1px 3px 0px rgb(0 0 0 / 12%);
	display: flex;
	align-items: center;
	flex-direction: column;

	hr {
		width: 100%;
		margin: 8px 0;
	}

	${({theme}) => theme.breakpoints.up("mobile")} {
		padding: 0 20px;
	}
`;

export const FormError = styled.div`
	color: ${({theme}) => theme.color.secondary};
`;
